module.exports = __webpack_public_path__ + "assets/img/ad8492339dc5277fbc8188c80355f6bf.webp";